// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableTab-module__font-s-10___LJkH_ {
  font-size: 10px !important;
}

.TableTab-module__font-s-12___pAris {
  font-size: 12px !important;
}

.TableTab-module__font-s-13___nagfb {
  font-size: 13px !important;
}

.TableTab-module__font-s-14___Agayy {
  font-size: 14px !important;
}

.TableTab-module__font-s-15___qkfEi {
  font-size: 15px !important;
}

.TableTab-module__font-s-16___ZifW4 {
  font-size: 16px !important;
}

.TableTab-module__font-s-18___ZM2pX {
  font-size: 18px !important;
}

.TableTab-module__font-s-20___SpsQq {
  font-size: 20px !important;
}

.TableTab-module__font-s-22___hPskZ {
  font-size: 22px !important;
}

.TableTab-module__font-s-28___H0ZyT {
  font-size: 28px !important;
}

.TableTab-module__font-w-400___SFU6j {
  font-weight: 400 !important;
}

.TableTab-module__font-w-500___xBcAi {
  font-weight: 500 !important;
}

.TableTab-module__font-w-600___navJB {
  font-weight: 600 !important;
}

.TableTab-module__font-w-700___i2BRK {
  font-weight: 700 !important;
}

.TableTab-module__p-5___vunvi {
  padding: 5px !important;
}

.TableTab-module__p-12___JPymn {
  padding: 12px !important;
}

.TableTab-module__p-16___g6zSo {
  padding: 16px !important;
}

.TableTab-module__p-30___J95bu {
  padding: 30px !important;
}

.TableTab-module__p-b-0___iOWJf {
  padding-bottom: 0 !important;
}

.TableTab-module__p-b-5___lk2ex {
  padding-bottom: 5px !important;
}

.TableTab-module__p-b-10___fC2pd {
  padding-bottom: 10px !important;
}

.TableTab-module__p-b-12___mRzn3 {
  padding-bottom: 12px !important;
}

.TableTab-module__p-b-16___FRImG {
  padding-bottom: 16px !important;
}

.TableTab-module__p-b-18___D5K24 {
  padding-bottom: 18px !important;
}

.TableTab-module__p-b-20___eEv4c {
  padding-bottom: 20px !important;
}

.TableTab-module__p-b-25___Hni6e {
  padding-bottom: 25px !important;
}

.TableTab-module__p-b-30___ztZQN {
  padding-bottom: 30px !important;
}

.TableTab-module__p-b-50___HnSqJ {
  padding-bottom: 50px !important;
}

.TableTab-module__p-t-0___GBIyP {
  padding-top: 0 !important;
}

.TableTab-module__p-t-12___L84yw {
  padding-top: 12px !important;
}

.TableTab-module__p-t-16___CT7lW {
  padding-top: 16px !important;
}

.TableTab-module__p-t-18___zbUfM {
  padding-top: 18px !important;
}

.TableTab-module__p-t-20___RBxgD {
  padding-top: 20px !important;
}

.TableTab-module__p-t-30___jNo9I {
  padding-top: 30px !important;
}

.TableTab-module__p-t-40___QLRFi {
  padding-top: 40px !important;
}

.TableTab-module__p-t-50___iGwBk {
  padding-top: 50px !important;
}

.TableTab-module__p-l-20___yxlZi {
  padding-left: 20px !important;
}

.TableTab-module__p-l-30___DM4mx {
  padding-left: 30px !important;
}

.TableTab-module__p-l-40___J2L8s {
  padding-left: 40px !important;
}

.TableTab-module__p-r-16___hdDFK {
  padding-right: 16px !important;
}

.TableTab-module__p-r-20___sApSa {
  padding-right: 20px !important;
}

.TableTab-module__p-r-30___KoX2S {
  padding-right: 30px !important;
}

.TableTab-module__p-r-50____Zvux {
  padding-right: 50px !important;
}

.TableTab-module__p-r-60___AP0eQ {
  padding-right: 60px !important;
}

.TableTab-module__m-b-1___P6_84 {
  margin-bottom: 1px !important;
}

.TableTab-module__m-b-2___lFbGd {
  margin-bottom: 2px !important;
}

.TableTab-module__m-b-6___PPWuT {
  margin-bottom: 6px !important;
}

.TableTab-module__m-b-8___yJmhp {
  margin-bottom: 8px !important;
}

.TableTab-module__m-b-10___B71S_ {
  margin-bottom: 10px !important;
}

.TableTab-module__m-b-14___qFz0k {
  margin-bottom: 14px !important;
}

.TableTab-module__m-b-16___SFJP3 {
  margin-bottom: 16px !important;
}

.TableTab-module__m-b-20___K1ehm {
  margin-bottom: 20px !important;
}

.TableTab-module__m-b-22___NYhJ5 {
  margin-bottom: 22px !important;
}

.TableTab-module__m-b-24___ryk6l {
  margin-bottom: 24px !important;
}

.TableTab-module__m-b-30___iYICh {
  margin-bottom: 30px !important;
}

.TableTab-module__m-b-32___ueqP9 {
  margin-bottom: 32px !important;
}

.TableTab-module__m-b-40___NylAo {
  margin-bottom: 40px !important;
}

.TableTab-module__m-t-2___xZD0W {
  margin-top: 2px !important;
}

.TableTab-module__m-t-3___eklCp {
  margin-top: 3px !important;
}

.TableTab-module__m-t-4___elHfi {
  margin-top: 4px !important;
}

.TableTab-module__m-t-5___GEyfd {
  margin-top: 5px !important;
}

.TableTab-module__m-t-8___iB40R {
  margin-top: 8px !important;
}

.TableTab-module__m-t-10___ldc61 {
  margin-top: 10px !important;
}

.TableTab-module__m-t-15___IT2hT {
  margin-top: 15px !important;
}

.TableTab-module__m-t-16___abFIZ {
  margin-top: 16px !important;
}

.TableTab-module__m-t-20___xnAdY {
  margin-top: 20px !important;
}

.TableTab-module__m-t-22___K2uoY {
  margin-top: 22px !important;
}

.TableTab-module__m-t-30___Ne1Pr {
  margin-top: 30px !important;
}

.TableTab-module__m-t-32___I4mVC {
  margin-top: 32px !important;
}

.TableTab-module__m-l-auto___tDHlq {
  margin-left: auto !important;
}

.TableTab-module__m-l-4___HOqHa {
  margin-left: 4px !important;
}

.TableTab-module__m-l-5___cMA2b {
  margin-left: 5px !important;
}

.TableTab-module__m-l-6___Eb7Le {
  margin-left: 6px !important;
}

.TableTab-module__m-l-8___g56O7 {
  margin-left: 8px !important;
}

.TableTab-module__m-l-10___M15TZ {
  margin-left: 10px !important;
}

.TableTab-module__m-l-16___BRhec {
  margin-left: 16px !important;
}

.TableTab-module__m-l-20___O3uGs {
  margin-left: 20px !important;
}

.TableTab-module__m-l-24___D2au6 {
  margin-left: 24px !important;
}

.TableTab-module__m-l-30___F_DEz {
  margin-left: 30px !important;
}

.TableTab-module__m-l-35___JBGyd {
  margin-left: 35px !important;
}

.TableTab-module__m-l-40___hMZbW {
  margin-left: 40px !important;
}

.TableTab-module__m-r-8___HiuVq {
  margin-right: 8px !important;
}

.TableTab-module__m-r-10___ERnWt {
  margin-right: 10px !important;
}

.TableTab-module__m-r-16___ncfFq {
  margin-right: 16px !important;
}

.TableTab-module__m-r-20___TkmIF {
  margin-right: 20px !important;
}

.TableTab-module__m-r-24___hDK1m {
  margin-right: 24px !important;
}

.TableTab-module__m-r-30___Hutpm {
  margin-right: 30px !important;
}

.TableTab-module__m-r-40___Jl_yV {
  margin-right: 40px !important;
}

.TableTab-module__border-r-3___HGodu {
  border-radius: 3px !important;
}

.TableTab-module__border-r-4___dg3Kb {
  border-radius: 4px !important;
}

.TableTab-module__border-r-6___bveBm {
  border-radius: 6px !important;
}

.TableTab-module__border-r-10___qiHjk {
  border-radius: 10px !important;
}

.TableTab-module__border-r-12___cEwt4 {
  border-radius: 12px !important;
}

.TableTab-module__border-r-16___tCIIw {
  border-radius: 16px !important;
}

.TableTab-module__border-r-50___Jk2cM {
  border-radius: 50% !important;
}

.TableTab-module__primary-border___TEw27 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TableTab-module__primary-border-b___qe1tS {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TableTab-module__primary-border-t___MczQT {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TableTab-module__primary-border-l___R_IRK {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TableTab-module__primary-border-r___HvnsV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TableTab-module__secondary-border___kc3hR {
  border: 1px solid #637768;
}

.TableTab-module__secondary-border-b___WN4m4 {
  border-bottom: 1px solid #637768;
}

.TableTab-module__secondary-border-t___xMKt5 {
  border-top: 1px solid #637768;
}

.TableTab-module__secondary-border-l___fwQoq {
  border-left: 1px solid #637768;
}

.TableTab-module__secondary-border-r___EUDkw {
  border-right: 1px solid #637768;
}

.TableTab-module__gap-0___lPc27 {
  gap: 0 !important;
}

.TableTab-module__gap-2___GSJCP {
  gap: 2px !important;
}

.TableTab-module__gap-4___GxVMD {
  gap: 4px !important;
}

.TableTab-module__gap-5___q4h3U {
  gap: 5px !important;
}

.TableTab-module__gap-6___ErQsV {
  gap: 6px !important;
}

.TableTab-module__gap-8___c2NI5 {
  gap: 8px !important;
}

.TableTab-module__gap-10___oA6gJ {
  gap: 10px !important;
}

.TableTab-module__gap-12___SNfLZ {
  gap: 12px !important;
}

.TableTab-module__gap-14___se9hO {
  gap: 14px !important;
}

.TableTab-module__gap-16___y0UCx {
  gap: 16px !important;
}

.TableTab-module__gap-18___bkJQh {
  gap: 18px !important;
}

.TableTab-module__gap-20___Ss9rs {
  gap: 20px !important;
}

.TableTab-module__gap-24___kSLXJ {
  gap: 24px !important;
}

.TableTab-module__gap-26___GgbWB {
  gap: 26px !important;
}

.TableTab-module__gap-30___UGFjU {
  gap: 30px !important;
}

.TableTab-module__gap-32___GQFFf {
  gap: 32px !important;
}

.TableTab-module__gap-40___OK23v {
  gap: 40px !important;
}

.TableTab-module__gap-50___hGAb9 {
  gap: 50px !important;
}

.TableTab-module__flex-1___K083f {
  flex: 1;
}

.TableTab-module__flex-none___QiPcU {
  flex: none !important;
}

.TableTab-module__flex-column___MP65z {
  display: flex;
  flex-direction: column !important;
}

.TableTab-module__flex-row___w20qb {
  display: flex;
  flex-direction: row !important;
}

.TableTab-module__vertically-centered___fvSfm {
  display: flex;
  align-items: center !important;
}

.TableTab-module__horizontally-centered___Ix9e2 {
  display: flex;
  justify-content: center !important;
}

.TableTab-module__horizontally-end___qix_o {
  display: flex;
  justify-content: end !important;
}

.TableTab-module__vertically-start___uuEx_ {
  display: flex;
  align-items: start !important;
}

.TableTab-module__space-between___tTHy3 {
  display: flex;
  justify-content: space-between !important;
}

.TableTab-module__flex-wrap___e76hA {
  flex-wrap: wrap !important;
}

.TableTab-module__height-100___e3hSw {
  height: 100%;
}

.TableTab-module__width-50___j4Oem {
  width: 50% !important;
}

.TableTab-module__width-100___TsAT0 {
  width: 100%;
}

.TableTab-module__cursor-pointer___Xv3iS {
  cursor: pointer;
}

.TableTab-module__cursor-not-allowed___qJVLF {
  cursor: not-allowed !important;
}

.TableTab-module__absolute-centered___PlRPj {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TableTab-module__absolute___cW7Id {
  position: absolute;
}

.TableTab-module__relative___W5885 {
  position: relative;
}

.TableTab-module__fixed___ws6Vj {
  position: fixed;
}

.TableTab-module__visible___LBS_a {
  opacity: 1;
}

.TableTab-module__invisible___H2_Fa {
  opacity: 0;
}

.TableTab-module__col-90___EpJmt {
  width: 90% !important;
}

.TableTab-module__col-auto___layRD {
  width: auto !important;
}

.TableTab-module__medical-tabs___E033g {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TableTab-module__medical-table-new___GOcvC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableTab-module__medical-table-new___GOcvC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableTab-module__medical-table-new___GOcvC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableTab-module__medical-table-new___GOcvC::-webkit-scrollbar-track {
  display: none;
}
.TableTab-module__medical-table-new___GOcvC.TableTab-module__no-pagination___kOmRs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableTab-module__medical-table-new___GOcvC.TableTab-module__no-pagination___kOmRs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableTab-module__medical-table-new___GOcvC.TableTab-module__no-pagination___kOmRs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableTab-module__medical-table-new___GOcvC.TableTab-module__no-pagination___kOmRs::-webkit-scrollbar-track {
  display: none;
}

.TableTab-module__medical-table-empty___XRVHT {
  padding: 14px 40px !important;
}

.TableTab-module__icon-btn___dF28C {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TableTab-module__search-icon___vUGS_ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TableTab-module__disable-select___FHC8s {
  user-select: none;
}

.TableTab-module__break-word___gszis {
  word-break: break-word;
}

.TableTab-module__popup-clear-btn___Cb8xa {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TableTab-module__scroll-m-b-20___CE5Su {
  scroll-margin-bottom: 20px;
}

.TableTab-module__grid___sPul3 {
  color: #637768;
  grid-template-columns: repeat(3, 200px);
  display: grid;
}

.TableTab-module__scroll___piGuT {
  height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableTab-module__scroll___piGuT:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableTab-module__scroll___piGuT::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableTab-module__scroll___piGuT::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/TrendedResultsPopup/tabs/TableTab/TableTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,uCAAA;EACA,aAAA;AA8pBF;;AA3pBA;ECEE,aDDwB;ECExB,kBAAA;EACA,kBAAA;AD6pBF;AC3pBE;EACE,oCAAA;EACA,mBAAA;AD6pBJ;AC1pBE;EACE,UAAA;EACA,6BAAA;AD4pBJ;ACzpBE;EACE,aAAA;AD2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  color: get-color(greenNew, medium-dark);\n  grid-template-columns: repeat(3, 200px);\n  display: grid;\n}\n\n.scroll {\n  @include verticalScroll(350px);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TableTab-module__font-s-10___LJkH_`,
	"fontS12": `TableTab-module__font-s-12___pAris`,
	"fontS13": `TableTab-module__font-s-13___nagfb`,
	"fontS14": `TableTab-module__font-s-14___Agayy`,
	"fontS15": `TableTab-module__font-s-15___qkfEi`,
	"fontS16": `TableTab-module__font-s-16___ZifW4`,
	"fontS18": `TableTab-module__font-s-18___ZM2pX`,
	"fontS20": `TableTab-module__font-s-20___SpsQq`,
	"fontS22": `TableTab-module__font-s-22___hPskZ`,
	"fontS28": `TableTab-module__font-s-28___H0ZyT`,
	"fontW400": `TableTab-module__font-w-400___SFU6j`,
	"fontW500": `TableTab-module__font-w-500___xBcAi`,
	"fontW600": `TableTab-module__font-w-600___navJB`,
	"fontW700": `TableTab-module__font-w-700___i2BRK`,
	"p5": `TableTab-module__p-5___vunvi`,
	"p12": `TableTab-module__p-12___JPymn`,
	"p16": `TableTab-module__p-16___g6zSo`,
	"p30": `TableTab-module__p-30___J95bu`,
	"pB0": `TableTab-module__p-b-0___iOWJf`,
	"pB5": `TableTab-module__p-b-5___lk2ex`,
	"pB10": `TableTab-module__p-b-10___fC2pd`,
	"pB12": `TableTab-module__p-b-12___mRzn3`,
	"pB16": `TableTab-module__p-b-16___FRImG`,
	"pB18": `TableTab-module__p-b-18___D5K24`,
	"pB20": `TableTab-module__p-b-20___eEv4c`,
	"pB25": `TableTab-module__p-b-25___Hni6e`,
	"pB30": `TableTab-module__p-b-30___ztZQN`,
	"pB50": `TableTab-module__p-b-50___HnSqJ`,
	"pT0": `TableTab-module__p-t-0___GBIyP`,
	"pT12": `TableTab-module__p-t-12___L84yw`,
	"pT16": `TableTab-module__p-t-16___CT7lW`,
	"pT18": `TableTab-module__p-t-18___zbUfM`,
	"pT20": `TableTab-module__p-t-20___RBxgD`,
	"pT30": `TableTab-module__p-t-30___jNo9I`,
	"pT40": `TableTab-module__p-t-40___QLRFi`,
	"pT50": `TableTab-module__p-t-50___iGwBk`,
	"pL20": `TableTab-module__p-l-20___yxlZi`,
	"pL30": `TableTab-module__p-l-30___DM4mx`,
	"pL40": `TableTab-module__p-l-40___J2L8s`,
	"pR16": `TableTab-module__p-r-16___hdDFK`,
	"pR20": `TableTab-module__p-r-20___sApSa`,
	"pR30": `TableTab-module__p-r-30___KoX2S`,
	"pR50": `TableTab-module__p-r-50____Zvux`,
	"pR60": `TableTab-module__p-r-60___AP0eQ`,
	"mB1": `TableTab-module__m-b-1___P6_84`,
	"mB2": `TableTab-module__m-b-2___lFbGd`,
	"mB6": `TableTab-module__m-b-6___PPWuT`,
	"mB8": `TableTab-module__m-b-8___yJmhp`,
	"mB10": `TableTab-module__m-b-10___B71S_`,
	"mB14": `TableTab-module__m-b-14___qFz0k`,
	"mB16": `TableTab-module__m-b-16___SFJP3`,
	"mB20": `TableTab-module__m-b-20___K1ehm`,
	"mB22": `TableTab-module__m-b-22___NYhJ5`,
	"mB24": `TableTab-module__m-b-24___ryk6l`,
	"mB30": `TableTab-module__m-b-30___iYICh`,
	"mB32": `TableTab-module__m-b-32___ueqP9`,
	"mB40": `TableTab-module__m-b-40___NylAo`,
	"mT2": `TableTab-module__m-t-2___xZD0W`,
	"mT3": `TableTab-module__m-t-3___eklCp`,
	"mT4": `TableTab-module__m-t-4___elHfi`,
	"mT5": `TableTab-module__m-t-5___GEyfd`,
	"mT8": `TableTab-module__m-t-8___iB40R`,
	"mT10": `TableTab-module__m-t-10___ldc61`,
	"mT15": `TableTab-module__m-t-15___IT2hT`,
	"mT16": `TableTab-module__m-t-16___abFIZ`,
	"mT20": `TableTab-module__m-t-20___xnAdY`,
	"mT22": `TableTab-module__m-t-22___K2uoY`,
	"mT30": `TableTab-module__m-t-30___Ne1Pr`,
	"mT32": `TableTab-module__m-t-32___I4mVC`,
	"mLAuto": `TableTab-module__m-l-auto___tDHlq`,
	"mL4": `TableTab-module__m-l-4___HOqHa`,
	"mL5": `TableTab-module__m-l-5___cMA2b`,
	"mL6": `TableTab-module__m-l-6___Eb7Le`,
	"mL8": `TableTab-module__m-l-8___g56O7`,
	"mL10": `TableTab-module__m-l-10___M15TZ`,
	"mL16": `TableTab-module__m-l-16___BRhec`,
	"mL20": `TableTab-module__m-l-20___O3uGs`,
	"mL24": `TableTab-module__m-l-24___D2au6`,
	"mL30": `TableTab-module__m-l-30___F_DEz`,
	"mL35": `TableTab-module__m-l-35___JBGyd`,
	"mL40": `TableTab-module__m-l-40___hMZbW`,
	"mR8": `TableTab-module__m-r-8___HiuVq`,
	"mR10": `TableTab-module__m-r-10___ERnWt`,
	"mR16": `TableTab-module__m-r-16___ncfFq`,
	"mR20": `TableTab-module__m-r-20___TkmIF`,
	"mR24": `TableTab-module__m-r-24___hDK1m`,
	"mR30": `TableTab-module__m-r-30___Hutpm`,
	"mR40": `TableTab-module__m-r-40___Jl_yV`,
	"borderR3": `TableTab-module__border-r-3___HGodu`,
	"borderR4": `TableTab-module__border-r-4___dg3Kb`,
	"borderR6": `TableTab-module__border-r-6___bveBm`,
	"borderR10": `TableTab-module__border-r-10___qiHjk`,
	"borderR12": `TableTab-module__border-r-12___cEwt4`,
	"borderR16": `TableTab-module__border-r-16___tCIIw`,
	"borderR50": `TableTab-module__border-r-50___Jk2cM`,
	"primaryBorder": `TableTab-module__primary-border___TEw27`,
	"primaryBorderB": `TableTab-module__primary-border-b___qe1tS`,
	"primaryBorderT": `TableTab-module__primary-border-t___MczQT`,
	"primaryBorderL": `TableTab-module__primary-border-l___R_IRK`,
	"primaryBorderR": `TableTab-module__primary-border-r___HvnsV`,
	"secondaryBorder": `TableTab-module__secondary-border___kc3hR`,
	"secondaryBorderB": `TableTab-module__secondary-border-b___WN4m4`,
	"secondaryBorderT": `TableTab-module__secondary-border-t___xMKt5`,
	"secondaryBorderL": `TableTab-module__secondary-border-l___fwQoq`,
	"secondaryBorderR": `TableTab-module__secondary-border-r___EUDkw`,
	"gap0": `TableTab-module__gap-0___lPc27`,
	"gap2": `TableTab-module__gap-2___GSJCP`,
	"gap4": `TableTab-module__gap-4___GxVMD`,
	"gap5": `TableTab-module__gap-5___q4h3U`,
	"gap6": `TableTab-module__gap-6___ErQsV`,
	"gap8": `TableTab-module__gap-8___c2NI5`,
	"gap10": `TableTab-module__gap-10___oA6gJ`,
	"gap12": `TableTab-module__gap-12___SNfLZ`,
	"gap14": `TableTab-module__gap-14___se9hO`,
	"gap16": `TableTab-module__gap-16___y0UCx`,
	"gap18": `TableTab-module__gap-18___bkJQh`,
	"gap20": `TableTab-module__gap-20___Ss9rs`,
	"gap24": `TableTab-module__gap-24___kSLXJ`,
	"gap26": `TableTab-module__gap-26___GgbWB`,
	"gap30": `TableTab-module__gap-30___UGFjU`,
	"gap32": `TableTab-module__gap-32___GQFFf`,
	"gap40": `TableTab-module__gap-40___OK23v`,
	"gap50": `TableTab-module__gap-50___hGAb9`,
	"flex1": `TableTab-module__flex-1___K083f`,
	"flexNone": `TableTab-module__flex-none___QiPcU`,
	"flexColumn": `TableTab-module__flex-column___MP65z`,
	"flexRow": `TableTab-module__flex-row___w20qb`,
	"verticallyCentered": `TableTab-module__vertically-centered___fvSfm`,
	"horizontallyCentered": `TableTab-module__horizontally-centered___Ix9e2`,
	"horizontallyEnd": `TableTab-module__horizontally-end___qix_o`,
	"verticallyStart": `TableTab-module__vertically-start___uuEx_`,
	"spaceBetween": `TableTab-module__space-between___tTHy3`,
	"flexWrap": `TableTab-module__flex-wrap___e76hA`,
	"height100": `TableTab-module__height-100___e3hSw`,
	"width50": `TableTab-module__width-50___j4Oem`,
	"width100": `TableTab-module__width-100___TsAT0`,
	"cursorPointer": `TableTab-module__cursor-pointer___Xv3iS`,
	"cursorNotAllowed": `TableTab-module__cursor-not-allowed___qJVLF`,
	"absoluteCentered": `TableTab-module__absolute-centered___PlRPj`,
	"absolute": `TableTab-module__absolute___cW7Id`,
	"relative": `TableTab-module__relative___W5885`,
	"fixed": `TableTab-module__fixed___ws6Vj`,
	"visible": `TableTab-module__visible___LBS_a`,
	"invisible": `TableTab-module__invisible___H2_Fa`,
	"col90": `TableTab-module__col-90___EpJmt`,
	"colAuto": `TableTab-module__col-auto___layRD`,
	"medicalTabs": `TableTab-module__medical-tabs___E033g`,
	"medicalTableNew": `TableTab-module__medical-table-new___GOcvC`,
	"noPagination": `TableTab-module__no-pagination___kOmRs`,
	"medicalTableEmpty": `TableTab-module__medical-table-empty___XRVHT`,
	"iconBtn": `TableTab-module__icon-btn___dF28C`,
	"searchIcon": `TableTab-module__search-icon___vUGS_`,
	"disableSelect": `TableTab-module__disable-select___FHC8s`,
	"breakWord": `TableTab-module__break-word___gszis`,
	"popupClearBtn": `TableTab-module__popup-clear-btn___Cb8xa`,
	"scrollMB20": `TableTab-module__scroll-m-b-20___CE5Su`,
	"grid": `TableTab-module__grid___sPul3`,
	"scroll": `TableTab-module__scroll___piGuT`
};
module.exports = ___CSS_LOADER_EXPORT___;
